class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    const searchLimit = this.input.dataset.limit;
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm,searchLimit);
  }
  getSearchResults(searchTerm,searchLimit) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[options][fields]=vendor,product_type,tag,body`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
      if(document.getElementById('SearchValueMobile')){
        document.getElementById('SearchValueMobile').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    $('#predictive-search-results').css('max-height',$(window).height());
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
     $('#predictive-search-results').css('max-height','auto');
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter');    
  });
});
document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});
// document.querySelector('.overlay-box').addEventListener('click',function(e){
//   document.querySelector('body').classList.remove('open-menu');
// });
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList) {
  sizeList.addEventListener('click', function(e) {
    e.preventDefault();

    let variant_id = sizeList.dataset.id;
    let free_id = sizeList.dataset.freeId || null;
    let freeTitle = sizeList.dataset.freeTitle || "Free Product";
    let freeImage = sizeList.dataset.freeImage || "";
    let freeColor = sizeList.dataset.freeColor || "";

    let error_grid_outer = sizeList.closest('.snippet-product-grid');
    let error_grid = error_grid_outer.querySelector('.grid-error');
    window.freeProductTitle = "{{ settings.freetitle }}";

    let formData = { 'items': [{ 'id': variant_id, 'quantity': 1 }] };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    })
    .then((response) => response.json())
    .then((data) => {
      if (data.status == 422) {
        error_grid.innerHTML = data.description;
        setTimeout(() => error_grid.innerHTML = '', 2000);
      } else {

        let mainImage = data.items[0].featured_image.url;
        let mainTitle = data.items[0].product_title.split("|")[0].split("-")[0];
        let mainPrice = Shopify.formatMoney(data.items[0].final_price);
        let optionColor = "", optionSize = "";

        data.items[0].options_with_values.forEach(option => {
          if (option.name == "Color") optionColor = option.value;
          if (option.name == "Size") optionSize = option.value;
        });

        let notificationHTML = `
          <div class="main_notification row">
            <div class="lef_notification">
              <img src="${mainImage}" alt="${mainTitle}">
            </div>
            <div class="center_notification">
              <div>
                <p>${mainTitle}</p>
                <div class="pro_var mt-6">
                  <div class="singal_var">${optionSize} / ${optionColor}</div>
                </div>
              </div>
            </div>
            <div class="right_notification">
              <div class="cart-price">${mainPrice}</div>
            </div>
          </div>
        `;

        if (free_id) {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cartData => {
              let freeAlreadyInCart = cartData.items.some(item => item.id == free_id);
              let freeTitleLiquid = document.querySelector("#cart-notification-product").dataset.freetitle;
              if (!freeAlreadyInCart) {
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ 'items': [{ 'id': free_id, 'quantity': 1 }] }),
                })
                .then(r => r.json())
                .then(freeRes => {
                  console.log("Free product added:", freeRes);
if (window.innerWidth > 767) {
                  notificationHTML += `
                    <div class="free-pdt-row">
                      <div class="lef_notification">
                        <img src="${freeImage}" alt="${freeTitle}">
                      </div>
                      <div class="right-text">
                        <div class="pdt-name">${freeTitleLiquid}</div>
                        <div class="color">${freeColor}</div>
                      </div>
                    </div>
                  `;
}
                  document.querySelector("#cart-notification-product").innerHTML = notificationHTML;

                  if (typeof load_cart === 'function') load_cart();
                })
                .catch(err => console.error("Error adding free product:", err));
              } else {
                document.querySelector("#cart-notification-product").innerHTML = notificationHTML;
              }
            });
        } else {
          document.querySelector("#cart-notification-product").innerHTML = notificationHTML;
        }

        if (typeof load_cart == 'function') {
          load_cart();
          setTimeout(() => { document.querySelector('body').classList.add('open-drawer'); }, 500);
        }

        fetch('/cart.js')
          .then(resp => resp.json())
          .then(function(cartData) {
            var cart_count = cartData.item_count;
            if (cart_count > 0) {
              document.querySelectorAll('.header-cart.none_991 .cart-count').forEach(c_count => {
                c_count.innerHTML = '(' + cart_count + ')';
              });
              document.querySelectorAll('.header-cart.block_991 .cart-count').forEach(c_count => {
                c_count.innerHTML = cart_count;
              });
              document.querySelector('.header-cart.block_991 .cart-count').classList.add('active');
            } else {
              document.querySelectorAll('.header-cart.none_991 .cart-count').forEach(c_count => {
                c_count.innerHTML = '(0)';
              });
              document.querySelectorAll('.header-cart.block_991 .cart-count').forEach(c_count => {
                c_count.innerHTML = 0;
              });
              document.querySelector('.header-cart.block_991 .cart-count').classList.remove('active');
            }
          });
      }
    })
    .catch((error) => {
      console.error(error);
    });
  });
});

//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
  }
  quickAddButton();
}
// if(document.querySelector('.mobile-nav .nav-wrap')){
//   document.querySelectorAll('.mobile-nav .nav-wrap a').forEach(function(navArrow){
//     navArrow.addEventListener('click',function(e){
//       navArrow.closest('li').classList.toggle('active');
//       document.querySelector('.snippet-menu-drawer').scrollTop = 0
//     });
//   });
// }

const navItems = document.querySelectorAll(".mobile-nav .nav-wrap");
navItems.forEach((navWrap) => {
  navWrap.addEventListener("click", function (e) {
    e.preventDefault();
    const currentDropdown = this.parentElement.querySelector(".navmobile-dropdown");

    // Close all dropdowns
    document.querySelectorAll(".navmobile-dropdown").forEach(dropdown => {
      if (dropdown !== currentDropdown) {
        dropdown.style.maxHeight = null;
        dropdown.classList.remove("open");
      }
    });

    // Toggle current
    if (currentDropdown.classList.contains("open")) {
      currentDropdown.style.maxHeight = null;
      currentDropdown.classList.remove("open");
    } else {
      currentDropdown.classList.add("open");
      currentDropdown.style.maxHeight = currentDropdown.scrollHeight + "px";
    }
  });
});

if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
    });
  });
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  }
};





























